module.exports = __webpack_public_path__ + "static/media/wood-bottom.c1250d92.png";